import { ICONOS, type NombreIcono } from './iconos';

interface IconProps {
  /** Nombre del icono en el catálogo (`src/presentation/components/ui/iconos.ts`). */
  nombre: NombreIcono;
  /** Tamaño en píxeles. */
  tamano?: number;
  color?: string;
  className?: string;
  /**
   * Texto para lectores de pantalla.
   * Si se omite, el icono se marca como decorativo: es lo correcto cuando va
   * junto a una etiqueta visible que ya dice lo mismo.
   */
  etiqueta?: string;
}

/**
 * Icono del sistema.
 *
 * El nombre está tipado contra el catálogo, así que un icono inexistente es un
 * error de compilación y no un hueco en blanco descubierto en producción.
 */
export function Icon({ nombre, tamano = 20, color, className, etiqueta }: IconProps) {
  const Svg = ICONOS[nombre];

  return (
    <Svg
      width={tamano}
      height={tamano}
      className={className}
      style={{ color, flexShrink: 0, display: 'block' }}
      aria-hidden={etiqueta ? undefined : true}
      aria-label={etiqueta}
      role={etiqueta ? 'img' : undefined}
    />
  );
}

export type { NombreIcono };
